import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import { IMAGE_BASE_URL } from "../../config/constants";
import { useImageCache } from "../../App";
import {
  itemPriority,
  itemDiscount,
  webStatus,
  webCategory
} from "../../config/constantselections";

const ItemDetailsCard = ({
  webcategory,
  image,
  itemcode,
  quantity,
  boxno,
  price,
  discount,
  webstatus,
  category,
  priority,
  sellingprice,
  balancequantity,
  totalsold,
  addToCart,
  inventoryid,
  isSelected,
  onSelectItem,
}) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(price);
  };

  const imageCache = useImageCache();
  const cachedImage = imageCache.get(image) || IMAGE_BASE_URL + image;
  const categoryDisplay = webCategory.find(cat => cat.value == webcategory)?.label || webcategory;
  const webStatusisplay = webStatus.find(cat => cat.value == webstatus)?.label || webstatus;
  const priorityDisplay = itemPriority.find(cat => cat.value == priority)?.label || priority;
  let circleColor = "green";
  if (balancequantity < 0) circleColor = "red";
  else if (balancequantity === 0) circleColor = "orange";

  return (
    <Card variant="outlined" sx={{ maxWidth: 600, margin: "auto" }}>
      <Grid container spacing={2} alignItems="center">
        {/* Left Image Section */}
        <Grid item xs={5}>
          <Box position="relative">
            <CardMedia
              component="img"
              sx={{
                height: { xs: 160, md: 200 },
                width: "100%",
                objectFit: "contain",
                borderRadius: "8px",
              }}
              image={cachedImage}
              alt={itemcode}
            />
            {/* Quantity Circle */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: circleColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: "bold",
              }}
            >
              {balancequantity}
            </Box>
          </Box>
        </Grid>

        {/* Right Details Section */}
        <Grid item xs={7}>
          <CardContent sx={{ padding: "8px 0 8px 0" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isSelected}
                  onChange={() => onSelectItem(inventoryid)}
                  color="primary"
                />
              }
              label="Select"
            />

            <Typography variant="h6" gutterBottom>
              {itemcode} {categoryDisplay}
            </Typography>

            {boxno && (
              <Typography variant="body2"><strong>Box No: {boxno}</strong></Typography>
            )}
            {price && (
              <Typography variant="body2">P.P: {formatPrice(price)}</Typography>
            )}
            {sellingprice && (
              <Typography variant="body2">S.P: {formatPrice(sellingprice)}</Typography>
            )}
                        {category && (
              <Typography variant="body2">Type:{category}</Typography>
            )}
              <Typography variant="body2">Discount :{discount}%</Typography>


              <Typography variant="body2">Web Status :{webStatusisplay}</Typography>
              <Typography variant="body2">Web Priority :{priorityDisplay}</Typography>
              
            {quantity && (
              <Typography variant="body2"><strong>Stocked: {quantity}</strong></Typography>
            )}

           
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ItemDetailsCard;